import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, } from "@mui/material";
import {
    SaveRounded,
} from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import CustomTextField from "../common/CustomTextField";
import CustomButton from "../common/CustomButton";
import { getCompanyTypes, } from "../../services/CommonServices";

const title = "Company Type";

const CompanyType = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [companyTypes, setCompanyTypes] = useState([]);


    const [leadModal, setLeadModal] = useState(false);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [formData, setFormData] = useState({
        leadName: "",
        leadOwner: null,
        leadSource: null,
        contactName: null,
        clientCompany: "",
        leadStatus: "",
        stage: "",
        priority: "",
        lossReason: "",
        productType: "",
        expectedTimeline: "",
        productRadio: "0",
        leadDescription: "",
    });

    const columns = useMemo(
        () => [
            { accessorKey: 'id', header: 'SN', size: 50 },
            { accessorKey: 'shortName', header: 'Short Name', size: 150 },
            { accessorKey: 'title', header: 'Compamy Type', size: 200 },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton onClick={() => handleViewClick(row.original.sn)}>
                        <VisibilityIcon />
                    </IconButton>
                ),
            },
        ],
        []
    );
 

    const handleViewClick = (id) => {
        navigate(`/app/abc/${id}`);
    };


    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const getCommonData = async () => {
        const companyTypesData = await getCompanyTypes();
        setCompanyTypes(companyTypesData);
    }
    useEffect(() => {
        getCommonData()
    }, [])


    return (
        <>
            <Box sx={{ paddingLeft: "10px" }} >

                <form>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="shortName"
                                fieldLabel="Short Name:"
                                value={formData.shortName}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Short Name"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="contactGroups"
                                fieldLabel="Compamy Type:"
                                value={formData.contactGroups}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Compamy Type"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <br />
                            <CustomButton
                                startIcon={<SaveRounded />}
                                title="Save"
                                size="small"
                                variant="contained"
                            />
                        </Grid>
                    </Grid>
                </form>

            </Box>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={companyTypes}
                />

            </Box>
        </>
    );
};
export default CompanyType;

 